import { Button } from "@/components/shadcn/ui/button";
import { toast } from "@/components/shadcn/ui/use-toast";
import { useBusiness } from "@/hook/useBusiness";
import type { ColDef } from "ag-grid-community";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";

ModuleRegistry.registerModules([AllCommunityModule]);

interface IRow {
  id: number;
  reason: string;
  description: string;
  contactNumber: string;
  email: string;
}

const GridCancelados = () => {
  const { getAllCanceled, revertCanceledBusiness } = useBusiness();
  const [rowData, setRowData] = useState<IRow[]>([]);


  const reverterCancelado = async (businessId: number) => {
    const dado = await revertCanceledBusiness(businessId);
    if (dado) {
      toast({ description: 'Negócio removido com sucesso!' });
      fetchData();
    }
  }

  const fetchData = async () => {
    try {
      const dados = await getAllCanceled();
      setRowData(dados);
    } catch (error) {
      console.error("Erro ao buscar cancelados:", error);
    }
  };

  // useEffect que roda APENAS na montagem do componente
  useEffect(() => {
    fetchData();
  }, []); // <-- Array de dependências vazio garante que roda apenas uma vez

  const colDefs: ColDef<IRow>[] = [
    { headerName: "Razão\ncancelamento", field: "reason" },
    { headerName: "Descrição", field: "description" },
    { headerName: "Número Contato", field: "contactNumber" },
    { field: "email" },
    {
      headerName: "Ações",
      cellRenderer: (params: { data: IRow; }) => {
        return (
          <Button
            className="px-3 py-1 bg-green-600 text-white rounded hover:bg-green-700"
            onClick={async () => {
              const dado = await revertCanceledBusiness(params.data.id);
              if (dado) {
                toast({ description: "Negócio retornado com sucesso!" });
                fetchData();
              }
            }}
          >Reverter</Button>
        );
      },
      width: 120, // opcional: define uma largura fixa
    }

  ];

  const defaultColDef: ColDef = {
    flex: 1,
  };

  return (
    <div
      className="flex flex-col items-center bg-indigo-200"
      style={{ height: "100vh" }}
    >
      <h1 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-2xl dark:text-white">
        Negócios Cancelados
      </h1>
      <div
        className="w-4/5 md:w-2/3"
        style={{ height: "500px" }}
      >
        <AgGridReact
          rowData={rowData}
          columnDefs={colDefs}
          defaultColDef={defaultColDef}
          localeText={{
            noRowsToShow: 'Nenhum dado encontrado',
          }}
        />
      </div>
    </div>
  );
};

export default GridCancelados;
